// ** React Imports
import { useEffect, useState } from 'react'

import { client } from 'src/utils/axios-client';
import { LeadScreenStore, LeadActivity, Lead, NextActivity, LeadActivityStore, ViewType, LeadAccountStore, LeadCompanyStore, SprintDialogStore, LeadSprintStore } from 'src/stores/LeadStore';
import { leadEndpoints } from '../../../configs/endpoints';

// ** MUI Imports
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import Typography from '@mui/material/Typography'
import CardContent from '@mui/material/CardContent'
import Tooltip from '@mui/material/Tooltip'
import Grid from '@mui/material/Grid'
import QuestionAnswerTwoToneIcon from '@mui/icons-material/QuestionAnswerTwoTone';
import _ from 'lodash';
import { ActivityReady } from 'src/utils/date-utils';
import LeadDataFormater from './LeadDataFormater';
import LeadCompanyComponent from './LeadCompanyComponent';
import LocalFireDepartmentTwoTone from '@mui/icons-material/LocalFireDepartmentTwoTone';

type Props = {
    accountLeadMode: boolean,
    sprintLeadMode: boolean,
    companyMode: boolean,
    sprintMode: boolean,
    sprintDialogMode: boolean
}


const AccountLeadList = ({ accountLeadMode, sprintLeadMode, companyMode, sprintMode, sprintDialogMode }: Props) => {
    var leads = LeadAccountStore.useState(s => s.record.accountLeads);
    if (sprintLeadMode == true) {
        leads = LeadAccountStore.useState(s => s.record.sprintLeads);
    }
    if (companyMode == true) {
        leads = LeadCompanyStore.useState(s => s.record.companyLeads);
    }
    if (sprintMode == true) {
        leads = LeadCompanyStore.useState(s => s.record.sprintLeads);
    }
    if (sprintDialogMode == true) {
        leads = LeadSprintStore.useState(s => s.record.sprintLeads);
    }
    return (
    <Box>
        {leads.map(record => (
            <Card sx={{ mb: 6 }} data-testid="activity-timeline" key={record.leadId}>
                <CardContent sx={{ pt: 1, display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                    <Grid container spacing={2} justifyContent={'center'} alignItems={'center'}>
                        <Grid item xs={6} justifyContent={'center'} alignItems={'center'} sx={{ pt: 1, display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                            <Grid item xs={12} justifyContent={'center'} alignItems={'center'} sx={{ pt: 1, display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                                <Typography variant='h6'>
                                    {record.leadName}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} justifyContent={'center'} alignItems={'center'} sx={{ pt: 1, display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                                <LeadDataFormater labelText='' valueText={record.jobTitle} textColor='CornflowerBlue' errorText='-Job Title is missing-' chipHeight={20} chipFontSize='0.875rem' chipfontWeight={500} isChip={false} />
                                {record.company != null && 
                                    <LeadDataFormater labelText='at' valueText={record.company} textColor='CornflowerBlue' errorText='-Company is missing-' chipHeight={20} chipFontSize='0.75rem' chipfontWeight={500} isChip={false} />
                                }
                            </Grid>
                            <Grid item xs={12} justifyContent={'center'} alignItems={'center'} sx={{ pt: 1, display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                                <Box sx={{ display: 'flex', alignItems: 'right' }}>
                                    {record.isHot &&
                                        <Tooltip title="Is a Hot Lead">
                                            <LocalFireDepartmentTwoTone sx={{ color: 'FireBrick' }} />
                                        </Tooltip>
                                    }
                                    {record.hasMI &&
                                        <Tooltip title="Has a Meaningful Interaction">
                                            <QuestionAnswerTwoToneIcon sx={{ color: 'LightSeaGreen' }} />
                                        </Tooltip>
                                    }
                                </Box>
                            </Grid>
                        </Grid>
                        <Grid item xs={6} justifyContent={'center'} alignItems={'center'} sx={{ pt: 1, display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                            <Grid item xs={12} justifyContent={'center'} alignItems={'center'} sx={{ pt: 1, display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                                <Box sx={{ display: 'flex', alignItems: 'right' }}>
                                    <LeadDataFormater labelText='' valueText={record.stageName} textColor={record.stageColor} errorText='-Not Set-' chipHeight={20} chipFontSize='0.75rem' chipfontWeight={500} isChip={true} />
                                </Box>
                            </Grid>
                            <Grid item xs={12} justifyContent={'center'} alignItems={'center'} sx={{ pt: 1, display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                                <Box sx={{ display: 'flex', alignItems: 'right' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        {record.country != '' &&
                                            <Tooltip title="Country" >
                                                <Typography variant="caption" >{record.country}</Typography>
                                            </Tooltip>
                                        }
                                        {record.country == '' &&
                                            <Tooltip title="Country" >
                                                <Typography variant="caption" >-Country Not Assigned-</Typography>
                                            </Tooltip>
                                        }
                                    </Box>
                                </Box>
                            </Grid>
                            <Grid item xs={12} justifyContent={'center'} alignItems={'center'} sx={{ pt: 1, display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                                <Box sx={{ display: 'flex', alignItems: 'right' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        {record.leadOwnerName != '' &&
                                            <Tooltip title="Primary lead owner" >
                                                <Typography variant="caption" sx={{ fontStyle: 'italic' }} >Owner: {record.leadOwnerName}</Typography>
                                            </Tooltip>
                                        }
                                        {record.leadOwnerName == '' &&
                                            <Tooltip title="Primary lead owner" >
                                                <Typography variant="caption" sx={{ fontStyle: 'italic' }} >Owner: -Not Assigned-</Typography>
                                            </Tooltip>
                                        }
                                    </Box>
                                </Box>
                            </Grid>
                            <Grid item xs={12} justifyContent={'center'} alignItems={'center'} sx={{ pt: 1, display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                                <Box sx={{ display: 'flex', alignItems: 'right' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        {record.sprintName != '' &&
                                            <Tooltip title="Primary lead owner" >
                                                <Typography variant="caption" sx={{ fontStyle: 'italic' }} >Sprint: {record.sprintName}</Typography>
                                            </Tooltip>
                                        }
                                        {record.sprintName == '' &&
                                            <Tooltip title="Primary lead owner" >
                                                <Typography variant="caption" sx={{ fontStyle: 'italic' }} >Sprint: -Not Assigned-</Typography>
                                            </Tooltip>
                                        }
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        ))
        }       
        </Box>
    )
    
}

export { AccountLeadList }

export default AccountLeadList;